import React, { useState } from "react";
import { Grid, MenuItem, TextField } from "@mui/material";
import moment from "moment/moment";

import { addSubcidioAsync } from "../../../../api/Nomina";
import { getToken } from "../../../../api/Account";
import { useAviso } from "../../../../components/base";
import {
  CampoFecha,
  DialogoFormulario,
  fechaCambiada,
  useEnvio,
  useEscritura,
} from "../comunes";

const AddSubcidio = ({ id, setShowModal, reload, setReload }) => {
  const [desde, setDesde] = useState(new Date());
  const [hasta, setHasta] = useState(new Date());
  const [riesgoLaboral, setRiesgoLaboral] = useState(1);
  const [motivo, setMotivo] = useState("");
  const [intentado, setIntentado] = useState(false);

  const token = getToken();
  const aviso = useAviso();
  const escribir = useEscritura();
  const { guardando, enviar } = useEnvio();

  // Las reglas de siempre y en el mismo orden: rango correcto, no menos de 4 días y motivo.
  // (El texto de siempre decía "menor a 3 días", pero la regla rechaza 3 días o menos: el texto
  // nuevo dice lo que la regla hace.)
  const errores = {};
  if (moment(desde).isAfter(moment(hasta))) {
    errores.hasta = "La fecha final no puede ser anterior a la inicial";
  } else if (moment(hasta).diff(moment(desde), "days") <= 2) {
    errores.hasta = "El subsidio debe ser de 4 días o más. Para 3 días o menos, registra un reposo.";
  }
  if (motivo.length === 0) errores.motivo = "Ingrese un motivo";

  const saveChanges = () =>
    enviar(async () => {
      setIntentado(true);
      if (Object.keys(errores).length > 0) return;

      const data = {
        employeeId: parseInt(id),
        motivo,
        desde: moment(desde).format("YYYY-MM-DD"),
        hasta: moment(hasta).format("YYYY-MM-DD"),
        isRiesgoLaboral: riesgoLaboral === 1,
      };

      const ok = await escribir(
        () => addSubcidioAsync(token, data),
        "No se pudo agregar el subsidio"
      );
      if (!ok) return;
      aviso.exito("Subsidio agregado");
      setReload(!reload);
      setShowModal(false);
    });

  const mostrar = intentado ? errores : {};

  return (
    <DialogoFormulario
      titulo="Agregar subsidio"
      onCerrar={() => setShowModal(false)}
      hayCambios={
        motivo !== "" || riesgoLaboral !== 1 || fechaCambiada(desde) || fechaCambiada(hasta)
      }
      guardando={guardando}
      onEnviar={saveChanges}
      textoEnviar="Agregar subsidio"
    >
      <Grid container spacing={2} sx={{ pt: 1 }}>
        <Grid item xs={12} sm={6}>
          <CampoFecha
            label="Desde"
            value={desde}
            onChange={(newValue) => setDesde(newValue)}
            disabled={guardando}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <CampoFecha
            label="Hasta"
            value={hasta}
            onChange={(newValue) => setHasta(newValue)}
            error={mostrar.hasta}
            ayuda="Desde 4 días. Hasta 3 días es un reposo."
            disabled={guardando}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            select
            fullWidth
            label="Tipo de subsidio"
            value={riesgoLaboral}
            onChange={(e) => setRiesgoLaboral(e.target.value)}
            helperText=" "
            disabled={guardando}
          >
            <MenuItem value={1}>RIESGO LABORAL</MenuItem>
            <MenuItem value={2}>OTRA CAUSA</MenuItem>
          </TextField>
        </Grid>
        <Grid item xs={12}>
          <TextField
            required
            fullWidth
            label="Motivo"
            value={motivo}
            onChange={(e) => setMotivo(e.target.value.toLocaleUpperCase())}
            error={Boolean(mostrar.motivo)}
            helperText={mostrar.motivo || " "}
            disabled={guardando}
            inputProps={{ autoComplete: "off" }}
          />
        </Grid>
      </Grid>
    </DialogoFormulario>
  );
};

export default AddSubcidio;
